
































































































































































































import {
  FormFieldOption,
  FormFieldType,
  FormFieldTypeEnum,
  IFormFieldData,
  IFormFieldOptionData,
  IFormFieldType,
  IFormSectionFieldData
} from '@/models';
import Draggable from 'vuedraggable';
import { PropType } from 'vue';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import { mapGetters } from 'vuex';
import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';

export default mixins(Proxyable).extend({
  name: 'FormBuilderOptionTabWindow',

  components: { Draggable, ConfirmationDialog },

  props: {
    value: Object as PropType<IFormSectionFieldData>
  },

  data() {
    return {
      selectedOptionsIndex: -1 as number,
      selectedEditOptionsIndex: -1 as number,
      deleteDialog: false
    };
  },

  computed: {
    ...mapGetters({
      getOptionTodosBySectionFieldAndOptionId:
        'formTemplate/getOptionTodosBySectionFieldAndOptionId',
      getFormFieldOptionTodos: 'formTemplate/getFormFieldOptionTodos'
    })
  },

  watch: {
    getFormFieldOptionTodos: {
      handler(value) {
        const canCreateTodo = value.length > 0;
        this.internalValue.create_todo = canCreateTodo;
      },
      immediate: true
    }
  },

  methods: {
    closeDeleteDialog() {
      this.selectedEditOptionsIndex = -1;
      this.selectedOptionsIndex = -1;
      this.deleteDialog = false;
    },

    setSelectedOption(option: IFormFieldOptionData) {
      this.$emit('openTodoDrawer', option);
    },

    reorderFieldTemplateOptions() {
      (this.internalValue.field_template as IFormFieldData).options = (this
        .internalValue.field_template as IFormFieldData).options?.map(
        (option, i) => {
          return {
            ...option,
            order: i
          };
        }
      );
    },

    openDialog(index: number) {
      this.selectedOptionsIndex = index;
      this.deleteDialog = true;
    },

    removeFieldTemplateOption() {
      (this.internalValue.field_template as IFormFieldData).options?.splice(
        this.selectedOptionsIndex!,
        1
      );

      //sync todo options and field options
      this.$emit('save');
      this.closeDeleteDialog();
      this.$emit('loadFieldOptionsTodos');
    },

    addFieldTemplateOption() {
      const option = new FormFieldOption({
        value: 'New Option',
        field: (this.internalValue.field_template as IFormFieldData).id!,
        order:
          (this.internalValue.field_template as IFormFieldData).options!
            .length + 1!
      });

      (this.internalValue.field_template as IFormFieldData).options?.push(
        option
      );

      this.selectedOptionsIndex =
        (this.internalValue.field_template as IFormFieldData).options!.length! -
        1;

      this.$emit('save');

      //opens newly create option for editting
      this.selectedEditOptionsIndex =
        (this.internalValue.field_template as IFormFieldData).options!.length -
        1!;
    }
  }
});
